/* AISEN header — mobile drawer, search toggle, accordion. Accessible, no deps. */
(function () {
  'use strict';
  function init() {
    var hdr = document.querySelector('.aisen-hdr');
    if (!hdr) return;
    var drawer = document.getElementById('aisen-drawer');
    var scrim = document.querySelector('.aisen-drawer__scrim');
    var burger = hdr.querySelector('.aisen-hdr__burger');
    var closeBtn = drawer ? drawer.querySelector('.aisen-drawer__close') : null;
    var lastFocus = null;

    function open() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      var f = drawer.querySelector('input, a, button');
      if (f) f.focus();
      document.addEventListener('keydown', onKey);
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (lastFocus) lastFocus.focus();
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    if (burger) burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (scrim) scrim.addEventListener('click', close);

    // search toggle (mobile): reveal drawer focused on search
    var searchToggle = hdr.querySelector('.aisen-hdr__search-toggle');
    if (searchToggle) searchToggle.addEventListener('click', function () {
      open();
      var s = drawer && drawer.querySelector('input[type="search"], input[name="q"]');
      if (s) setTimeout(function () { s.focus(); }, 60);
    });

    // drawer accordions (funciona em qualquer profundidade, incl. Suporte Técnico aninhado)
    (drawer ? drawer.querySelectorAll('.aisen-drawer__row[data-sub]') : []).forEach(function (row) {
      row.addEventListener('click', function () {
        var sub = document.getElementById(row.getAttribute('data-sub'));
        var open = row.getAttribute('aria-expanded') === 'true';
        row.setAttribute('aria-expanded', String(!open));
        if (sub) sub.classList.toggle('is-open', !open);
      });
    });

    // desktop: mega Suporte Técnico — a11y (aria-expanded + Escape devolve o foco)
    var sup = hdr.querySelector('.aisen-nav__item--support');
    if (sup) {
      var supLink = sup.querySelector('.aisen-nav__link');
      var setExp = function (v) { if (supLink) supLink.setAttribute('aria-expanded', String(v)); };
      sup.addEventListener('mouseenter', function () { setExp(true); });
      sup.addEventListener('mouseleave', function () { if (!sup.contains(document.activeElement)) setExp(false); });
      sup.addEventListener('focusin', function () { setExp(true); });
      sup.addEventListener('focusout', function () { setTimeout(function () { if (!sup.contains(document.activeElement)) setExp(false); }, 0); });
      sup.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setExp(false); if (supLink) supLink.focus(); } });
    }
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
